// FloatingNotificationBell.js - Floating notification bell for every page
import React, { useState, useEffect } from 'react';
import NotificationBell from './NotificationBell';

const FloatingNotificationBell = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);

  // Optional: Auto-hide on scroll down, show on scroll up
  useEffect(() => {
    let lastScrollY = window.scrollY;
    
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show when scrolling up, hide when scrolling down fast
      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY + 10) {
        setIsVisible(false);
      }
      
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isMinimized) {
    return (
      <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-70'
      }`}>
        <button
          onClick={() => setIsMinimized(false)}
          className="bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg border-2 border-white p-2 transition-all duration-200 hover:scale-110"
          title="Show notifications"
        >
          <NotificationBell />
        </button>
      </div>
    );
  }

  return (
    <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
      isVisible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-70'
    }`}>
      {/* Main floating container */}
      <div className="bg-white rounded-full shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-200 hover:scale-105">
        <div className="relative">
          <NotificationBell />
          
          {/* Optional minimize button */}
          <button
            onClick={() => setIsMinimized(true)}
            className="absolute -top-1 -left-1 bg-gray-100 hover:bg-gray-200 text-gray-500 rounded-full w-5 h-5 flex items-center justify-center text-xs transition-colors opacity-0 group-hover:opacity-100"
            title="Minimize notifications"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingNotificationBell;